<template>
	<div class="join border w-fit">
		<button type="button" data-testid="minus-button" @click="decrement()" class="btn btn-ghost join-item px-2" :class="[size === 'sm'? 'btn-sm' : '', buttonClasses]">
			<MinusIcon :class="[size === 'sm'? 'w-4 h-4' : 'w-5 h-5']" />
		</button>
		<input id="number" type="text" inputmode="numeric" pattern="\d+" readonly required name="number"
			v-model="number"
			class="input text-center join-item bg-input flex-shrink-0 px-1"
			:class="[size === 'sm'? 'input-xs w-8 h-8' : 'w-14', inputClasses]"
		/>
		<button type="button" data-testid="plus-button" @click="increment()" class="btn btn-ghost join-item px-2 m-0" :class="[size === 'sm'? 'btn-sm' : '', buttonClasses]">
			<PlusIcon :class="[size === 'sm'? 'w-4 h-4' : 'w-5 h-5']" />
		</button>
	</div>
</template>


<script lang="ts">
import { PlusIcon, MinusIcon } from '@heroicons/vue/24/outline';

export default {
	props: {
		modelValue: {
			type: Number,
			default: 0,
		},
		stepValue: {
			type: Number,
			default: 1,
		},
		size: {
			type: String,
			default: 'md',
		},
		buttonClasses: {
			type: String,
			default: '',
		},
		inputClasses: {
			type: String,
			default: '',
		},
	},

	components: {
		PlusIcon,
		MinusIcon,
	},

	data() {
		return {
			number: this.modelValue,
		};
	},

	watch: {
		// Whenever modelValue changes from the outside,
		// update our local number
		modelValue(newValue) {
			this.number = newValue;
		}
	},

	methods: {
		increment() {
			this.number += this.stepValue;
			this.$emit('update:modelValue', this.number);
		},
		decrement() {
			this.number = Math.max(0, this.number - this.stepValue);
			this.$emit('update:modelValue', this.number);
		},
	},
};
</script>
